module.exports = __webpack_public_path__ + "img/charge_offline.3f58f755.png";